import React, { useEffect, useMemo, useState } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import styled from "styled-components";
import useDisplay from "../../hooks/useDisplay";
import PCContainer from "../../components/atoms/layout/pcContainer";
import LSRgDisplay02 from "../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import LSRgH2HeadLine from "./../../components/molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import Pagination from "../../components/molecules/pagination";
import { route } from "./../../router/route";
import LSRgBody01 from "./../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import { consultingTabList } from "../../constant/consultingTabList";
import LSBdH1HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH1HeadLine";
import PretendardText from "../../components/atoms/text/pretendardText";
import LSRgBody02 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody02";
import LSBdDisplay02 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import InputLabel from "../../components/atoms/input/inputLabel";
import InputField from "../../components/atoms/input/inputField";
import Checkbox from "./../../components/atoms/input/checkbox";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import MainBtn from "./../../components/atoms/button/mainBtn";
import SelectBox from "../../components/organisms/SelectBox";
import MOContainer from "../../components/atoms/layout/moContainer";
import LSRgCaption03 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption03";
import LSRgCaption02 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption02";
import TermApi from "../../api/term.api";
import ConsultingApi from "../../api/consulting.api";
import { errorHandler } from "../../util/errorHandler";
import moment from "moment";
import { fileDownload } from "../../util/fileManagement";
import Empty from "../../components/molecules/empty";
import { macOSCheck } from "../../util/macOSCheck";
import StyledCategoryItem from "../../components/molecules/button/styledCategoryItem";
import { toast } from "react-toastify";
import Loading from "../../components/templates/loading";

const ConsultingProgressDetail = () => {
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const { id } = useParams();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars

  const [postList, setPostList] = useState([]);

  const page = useMemo(() => {
    const requestedPage = Number(searchParams.get("page"));
    return Number.isInteger(requestedPage) && requestedPage > 0
      ? requestedPage
      : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 5, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  const [subMenuBoxOpen, setSubMenuBoxOpen] = useState(false);
  const [selectedSubMenu, setSelectedSubMenu] = useState(
    consultingTabList[3].title,
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") return;
    dataListFunc();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("컨설팅 내역을 확인하려면 로그인을 해주세요.");
      navigate(route.login, {
        replace: true,
        state: { path: window.location.href },
      });
      return;
    }

    const consultingId = Number(id);
    if (!Number.isInteger(consultingId) || consultingId <= 0) {
      toast("잘못된 컨설팅 내역 주소입니다.");
      navigate(route.consulting_progress, { replace: true });
      return;
    }

    getTermData();
    getConsultingDetail();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [consultingData, setConsultingData] = useState({});
  const [termData, setTermData] = useState({});

  const getConsultingDetail = async () => {
    setIsLoading(true);
    try {
      const response = (await ConsultingApi.getMyConsultingDetail(id)).data.data
        .content;

      setConsultingData(response);
    } catch (error) {
      errorHandler(error);
      navigate(route.consulting_progress, { replace: true });
    } finally {
      setIsLoading(false);
    }
  };

  const getTermData = async () => {
    try {
      const response = (await TermApi.getDetail(8)).data.data.content;

      setTermData(response);
    } catch (error) {
      console.error(error);
    }
  };

  const dataListFunc = async () => {
    try {
      const data = {
        page: page,
        size: pagination.size,
        consultingStatus: "SUBMIT",
      };

      const response = (await ConsultingApi.getMyConsultingList(data)).data
        .data;

      setPostList(response.content ?? []);
      setPagination((prev) => ({
        ...prev,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / prev.size),
      }));
    } catch (error) {
      errorHandler(error);
    }
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <HomeSection $isSmall={isSmall}>
      {isDesktop && (
        <PCContainer
          style={{
            flexDirection: "column",
            width: "100%",
            padding: isSmall ? "0px 20px" : "0px",
          }}
        >
          <LSRgDisplay02
            style={{
              marginBottom: 32,
            }}
          >
            📋 1:1 컨설팅
          </LSRgDisplay02>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "fit-content",
              gap: 30,
            }}
          >
            {/* 탭 영역 */}
            <TabContainer>
              {consultingTabList.map((tab, index) => (
                <StyledCategoryItem
                  key={index}
                  onClick={() => navigate(tab.path)}
                  isActive={index === 3 ? true : false}
                  title={tab.title}
                />
              ))}
            </TabContainer>
            {/* 본문 영역 */}
            <ContentContainer>
              <ContentWrapper>
                <ContentHeaderWrapper>
                  <LSBdDisplay02 style={{ color: "#101113" }}>
                    필요 서류 제출
                  </LSBdDisplay02>
                  <LSRgH1HeadLine style={{ color: "#474747" }}>
                    컨설팅 당일로부터 2일 전까지 제출 부탁드립니다.
                  </LSRgH1HeadLine>
                </ContentHeaderWrapper>

                <InputContainer>
                  <InputLabel
                    style={{
                      width: 447,
                    }}
                  >
                    <InputTitleWrapper>
                      <LSBdH1HeadLine style={{ color: "#101113" }}>
                        컨설팅 희망 날짜
                      </LSBdH1HeadLine>
                      <InputTitleRequiredDot />
                    </InputTitleWrapper>
                    <InputField
                      id="date"
                      name="date"
                      placeholder="YYYYMMDD"
                      type="text"
                      autoComplete="off"
                      value={moment(consultingData?.hopeDate).format(
                        "YYYY-MM-DD",
                      )}
                      required={true}
                    />
                  </InputLabel>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <InputLabel
                      style={{
                        width: 447,
                      }}
                    >
                      <InputTitleWrapper>
                        <LSBdH1HeadLine style={{ color: "#101113" }}>
                          토스 신용점수 캡쳐화면
                        </LSBdH1HeadLine>
                        <InputTitleRequiredDot />
                      </InputTitleWrapper>
                      <InputFileWrapper
                        onClick={() => {
                          fileDownload(
                            consultingData?.fileServerFileName1,
                            consultingData?.fileOriginFileName1,
                          );
                        }}
                      >
                        <LSBdH1HeadLine
                          style={{
                            marginTop: macOSCheck() ? 0 : 2,
                            color: "#A4A8B1",
                            whiteSpace: "nowrap", // 텍스트를 한 줄로 유지
                            overflow: "hidden", // 넘치는 텍스트를 숨김
                            textOverflow: "ellipsis", // 넘치는 텍스트를 "..."으로 표시
                          }}
                        >
                          {consultingData?.fileOriginFileName1}
                        </LSBdH1HeadLine>
                        <img
                          src="/assets/icons/clip_disabled.png"
                          alt="파일 업로드"
                          style={{
                            width: 16,
                            height: 16,
                            objectFit: "cover",
                          }}
                        />
                      </InputFileWrapper>
                    </InputLabel>
                    <InputLabel
                      style={{
                        width: 447,
                      }}
                    >
                      <InputTitleWrapper>
                        <LSBdH1HeadLine style={{ color: "#101113" }}>
                          토스 신용점수 캡쳐화면 아래 대출상세내역
                        </LSBdH1HeadLine>
                        <InputTitleRequiredDot />
                      </InputTitleWrapper>
                      <InputFileWrapper
                        onClick={() => {
                          fileDownload(
                            consultingData?.fileServerFileName2,
                            consultingData?.fileOriginFileName2,
                          );
                        }}
                      >
                        <LSBdH1HeadLine
                          style={{
                            marginTop: macOSCheck() ? 0 : 2,
                            color: "#A4A8B1",
                            whiteSpace: "nowrap", // 텍스트를 한 줄로 유지
                            overflow: "hidden", // 넘치는 텍스트를 숨김
                            textOverflow: "ellipsis", // 넘치는 텍스트를 "..."으로 표시
                          }}
                        >
                          {consultingData?.fileOriginFileName2}
                        </LSBdH1HeadLine>
                        <img
                          src="/assets/icons/clip_disabled.png"
                          alt="파일 업로드"
                          style={{
                            width: 16,
                            height: 16,
                            objectFit: "cover",
                          }}
                        />
                      </InputFileWrapper>
                    </InputLabel>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <InputLabel
                      style={{
                        width: 447,
                      }}
                    >
                      <InputTitleWrapper>
                        <LSBdH1HeadLine style={{ color: "#101113" }}>
                          보유부동산 및 가계상황
                        </LSBdH1HeadLine>
                        <LSRgBody02 style={{ color: "#101113" }}>
                          (양식 다운로드: http://naver.me/5jmhPXz1)
                        </LSRgBody02>
                        <InputTitleRequiredDot />
                      </InputTitleWrapper>
                      <InputFileWrapper
                        onClick={() => {
                          fileDownload(
                            consultingData?.fileServerFileName3,
                            consultingData?.fileOriginFileName3,
                          );
                        }}
                      >
                        <LSBdH1HeadLine
                          style={{
                            marginTop: macOSCheck() ? 0 : 2,
                            color: "#A4A8B1",
                            whiteSpace: "nowrap", // 텍스트를 한 줄로 유지
                            overflow: "hidden", // 넘치는 텍스트를 숨김
                            textOverflow: "ellipsis", // 넘치는 텍스트를 "..."으로 표시
                          }}
                        >
                          {consultingData?.fileOriginFileName3}
                        </LSBdH1HeadLine>
                        <img
                          src="/assets/icons/clip_disabled.png"
                          alt="파일 업로드"
                          style={{
                            width: 16,
                            height: 16,
                            objectFit: "cover",
                          }}
                        />
                      </InputFileWrapper>
                    </InputLabel>
                    <InputLabel
                      style={{
                        width: 447,
                      }}
                    >
                      <InputTitleWrapper>
                        <LSBdH1HeadLine style={{ color: "#101113" }}>
                          사업자 등록증 (사업자일 경우)
                        </LSBdH1HeadLine>
                        <InputTitleRequiredDot />
                      </InputTitleWrapper>
                      <InputFileWrapper
                        onClick={() => {
                          fileDownload(
                            consultingData?.fileServerFileName4,
                            consultingData?.fileOriginFileName4,
                          );
                        }}
                      >
                        <LSBdH1HeadLine
                          style={{
                            marginTop: macOSCheck() ? 0 : 2,
                            color: "#A4A8B1",
                            whiteSpace: "nowrap", // 텍스트를 한 줄로 유지
                            overflow: "hidden", // 넘치는 텍스트를 숨김
                            textOverflow: "ellipsis", // 넘치는 텍스트를 "..."으로 표시
                          }}
                        >
                          {consultingData?.fileOriginFileName4}
                        </LSBdH1HeadLine>
                        <img
                          src="/assets/icons/clip_disabled.png"
                          alt="파일 업로드"
                          style={{
                            width: 16,
                            height: 16,
                            objectFit: "cover",
                          }}
                        />
                      </InputFileWrapper>
                    </InputLabel>
                  </div>

                  <InputLabel
                    style={{
                      width: 447,
                    }}
                  >
                    <InputTitleWrapper>
                      <LSBdH1HeadLine style={{ color: "#101113" }}>
                        최근 결산기 부가가치세 과세표준증명원 (사업자일 경우)
                      </LSBdH1HeadLine>
                      <InputTitleRequiredDot />
                    </InputTitleWrapper>
                    <InputFileWrapper
                      onClick={() => {
                        fileDownload(
                          consultingData?.fileServerFileName5,
                          consultingData?.fileOriginFileName5,
                        );
                      }}
                    >
                      <LSBdH1HeadLine
                        style={{
                          marginTop: macOSCheck() ? 0 : 2,
                          color: "#A4A8B1",

                          whiteSpace: "nowrap", // 텍스트를 한 줄로 유지
                          overflow: "hidden", // 넘치는 텍스트를 숨김
                          textOverflow: "ellipsis", // 넘치는 텍스트를 "..."으로 표시
                        }}
                      >
                        {consultingData?.fileOriginFileName5}
                      </LSBdH1HeadLine>
                      <img
                        src="/assets/icons/clip_disabled.png"
                        alt="파일 업로드"
                        style={{
                          width: 16,
                          height: 16,
                          objectFit: "cover",
                        }}
                      />
                    </InputFileWrapper>
                  </InputLabel>

                  <InputLabel>
                    <InputTitleWrapper>
                      <LSBdH1HeadLine style={{ color: "#101113" }}>
                        개인정보 수집 및 이용 동의(필수)
                      </LSBdH1HeadLine>
                      <InputTitleRequiredDot />
                    </InputTitleWrapper>
                    <AgreementContainer>
                      <AgreementWrapper className="custom-scrollbar">
                        <PretendardText
                          style={{
                            fontWeight: 400,
                            fontSize: 12,
                            lineHeight: "19.2px",
                            letterSpacing: "-0.6px",
                            color: "#A4A8B1",
                          }}
                        >
                          {termData?.content || ""}
                        </PretendardText>
                      </AgreementWrapper>
                    </AgreementContainer>
                    <Checkbox
                      id="privacyAgree"
                      name="privacyAgree"
                      checked={true}
                      value="Agree"
                      valueText="개인정보 수집 및 이용에 동의합니다."
                      onChange={() => {}}
                      required={true}
                      style={{ marginTop: 6 }}
                    />
                  </InputLabel>
                </InputContainer>
              </ContentWrapper>

              <TableWrapper>
                <ContentHeaderWrapper>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <LSRgDisplay02>이전 컨설팅 내역</LSRgDisplay02>
                    <MainBtn
                      style={{
                        height: 36,
                        width: 94,
                        borderRadius: 8,
                      }}
                      onClick={() => {
                        navigate(route.consulting_progress);
                      }}
                    >
                      <LSRgBody01
                        style={{
                          color: "#fff",
                          textAlign: "center",
                          marginTop: macOSCheck() ? 0 : 2,
                        }}
                      >
                        새 서류 제출
                      </LSRgBody01>
                    </MainBtn>
                  </div>
                  <LSRgH2HeadLine>
                    이전 진행한 컨설팅 내역을 확인하실 수 있습니다.
                  </LSRgH2HeadLine>
                </ContentHeaderWrapper>

                {/* 본문 영역 - 테이블 */}
                <Table>
                  <tbody>
                    {postList.length > 0 ? (
                      postList.map((item, index) => (
                        <Tr
                          key={index}
                          style={{
                            borderTop: index === 0 && "1px solid #dbdde0",
                          }}
                        >
                          <td
                            style={{
                              marginRight: 312,
                            }}
                          >
                            <LSRgH2HeadLine
                              style={{
                                color: "#101113",
                                width: 575,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                navigate(
                                  `${route.consulting_progress_detail}/${item.id}`,
                                );
                              }}
                            >
                              {item.necessaryPart}
                            </LSRgH2HeadLine>
                          </td>
                          <td
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: 88,
                            }}
                          >
                            <LSRgBody01 style={{ color: "#898E99" }}>
                              {moment(item.createdAt).format("YYYY.MM.DD")}
                            </LSRgBody01>
                          </td>
                        </Tr>
                      ))
                    ) : (
                      <Empty title={"이전 컨설팅 내역이 없습니다."} />
                    )}
                  </tbody>
                </Table>

                {postList.length > 0 && (
                  <Pagination
                    route={`${route.consulting_progress_detail}/${id}`}
                    queryString={``}
                    currentPage={Number(page) || 1}
                    totalPages={pagination.totalPages}
                    rangeSize={pagination.rangeSize}
                  />
                )}
              </TableWrapper>
            </ContentContainer>
          </div>
        </PCContainer>
      )}

      {/* ******************************** */}
      {/* ********** 모바일 버전 ********** */}
      {/* ******************************** */}
      {isSmall && (
        <MOContainer>
          <ContentContainer $isSmall={isSmall}>
            <ContentHeaderWrapper $isSmall={isSmall}>
              <LSRgH1HeadLine>📋 1:1 컨설팅</LSRgH1HeadLine>
              <SelectBox
                style={{
                  width: "100%",
                }}
                subMenuStyle={{
                  width: "100%",
                }}
                isSmall={true}
                isOpen={subMenuBoxOpen}
                isLink={true}
                selectedValue={selectedSubMenu}
                wrapperHandler={() => {
                  setSubMenuBoxOpen(!subMenuBoxOpen);
                }}
                itemList={consultingTabList}
                selectedValueSetterFunc={setSelectedSubMenu}
              />
            </ContentHeaderWrapper>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 4,
              }}
            >
              <LSRgH1HeadLine>사전 상담 신청</LSRgH1HeadLine>
              <LSRgBody01 style={{ color: "#101113" }}>
                컨설팅 당일로부터 2일 전까지 제출 부탁드립니다.
              </LSRgBody01>
            </div>

            <InputContainer $isSmall={isSmall}>
              <InputLabel>
                <InputTitleWrapper>
                  <LSBdH1HeadLine style={{ color: "#101113" }}>
                    컨설팅 희망 날짜
                  </LSBdH1HeadLine>
                  <InputTitleRequiredDot />
                </InputTitleWrapper>
                <InputField
                  id="date"
                  name="date"
                  placeholder="YYYYMMDD"
                  type="text"
                  autoComplete="off"
                  value={moment(consultingData?.hopeDate).format("YYYY-MM-DD")}
                  required={true}
                />
              </InputLabel>

              <InputLabel>
                <InputTitleWrapper>
                  <LSBdH1HeadLine style={{ color: "#101113" }}>
                    토스 신용점수 캡쳐화면
                  </LSBdH1HeadLine>
                  <InputTitleRequiredDot />
                </InputTitleWrapper>
                <InputFileWrapper
                  $isSmall={isSmall}
                  onClick={() => {
                    fileDownload(
                      consultingData?.fileServerFileName1,
                      consultingData?.fileOriginFileName1,
                    );
                  }}
                >
                  <LSBdH1HeadLine
                    style={{
                      marginTop: macOSCheck() ? 0 : 2,
                      color: "#A4A8B1",
                      whiteSpace: "nowrap", // 텍스트를 한 줄로 유지
                      overflow: "hidden", // 넘치는 텍스트를 숨김
                      textOverflow: "ellipsis", // 넘치는 텍스트를 "..."으로 표시
                    }}
                  >
                    {consultingData?.fileOriginFileName1}
                  </LSBdH1HeadLine>
                  <img
                    src="/assets/icons/clip_disabled.png"
                    alt="파일 업로드"
                    style={{
                      width: 16,
                      height: 16,
                      objectFit: "cover",
                    }}
                  />
                </InputFileWrapper>
              </InputLabel>
              <InputLabel>
                <InputTitleWrapper>
                  <LSBdH1HeadLine style={{ color: "#101113" }}>
                    토스 신용점수 캡쳐화면 아래 대출상세내역
                  </LSBdH1HeadLine>
                  <InputTitleRequiredDot />
                </InputTitleWrapper>
                <InputFileWrapper
                  $isSmall={isSmall}
                  onClick={() => {
                    fileDownload(
                      consultingData?.fileServerFileName2,
                      consultingData?.fileOriginFileName2,
                    );
                  }}
                >
                  <LSBdH1HeadLine
                    style={{
                      marginTop: macOSCheck() ? 0 : 2,
                      color: "#A4A8B1",
                      whiteSpace: "nowrap", // 텍스트를 한 줄로 유지
                      overflow: "hidden", // 넘치는 텍스트를 숨김
                      textOverflow: "ellipsis", // 넘치는 텍스트를 "..."으로 표시
                    }}
                  >
                    {consultingData?.fileOriginFileName2}
                  </LSBdH1HeadLine>
                  <img
                    src="/assets/icons/clip_disabled.png"
                    alt="파일 업로드"
                    style={{
                      width: 16,
                      height: 16,
                      objectFit: "cover",
                    }}
                  />
                </InputFileWrapper>
              </InputLabel>

              <InputLabel>
                <InputTitleWrapper>
                  <LSBdH1HeadLine style={{ color: "#101113" }}>
                    보유부동산 및 가계상황
                  </LSBdH1HeadLine>
                  <InputTitleRequiredDot />
                </InputTitleWrapper>
                <LSRgCaption03 style={{ color: "#101113" }}>
                  (양식 다운로드: http://naver.me/5jmhPXz1)
                </LSRgCaption03>
                <InputFileWrapper
                  $isSmall={isSmall}
                  onClick={() => {
                    fileDownload(
                      consultingData?.fileServerFileName3,
                      consultingData?.fileOriginFileName3,
                    );
                  }}
                >
                  <LSBdH1HeadLine
                    style={{
                      marginTop: macOSCheck() ? 0 : 2,
                      color: "#A4A8B1",
                      whiteSpace: "nowrap", // 텍스트를 한 줄로 유지
                      overflow: "hidden", // 넘치는 텍스트를 숨김
                      textOverflow: "ellipsis", // 넘치는 텍스트를 "..."으로 표시
                    }}
                  >
                    {consultingData?.fileOriginFileName3}
                  </LSBdH1HeadLine>
                  <img
                    src="/assets/icons/clip_disabled.png"
                    alt="파일 업로드"
                    style={{
                      width: 16,
                      height: 16,
                      objectFit: "cover",
                    }}
                  />
                </InputFileWrapper>
              </InputLabel>
              <InputLabel>
                <InputTitleWrapper>
                  <LSBdH1HeadLine style={{ color: "#101113" }}>
                    사업자 등록증 (사업자일 경우)
                  </LSBdH1HeadLine>
                  <InputTitleRequiredDot />
                </InputTitleWrapper>
                <InputFileWrapper
                  $isSmall={isSmall}
                  onClick={() => {
                    fileDownload(
                      consultingData?.fileServerFileName4,
                      consultingData?.fileOriginFileName4,
                    );
                  }}
                >
                  <LSBdH1HeadLine
                    style={{
                      marginTop: macOSCheck() ? 0 : 2,
                      color: "#A4A8B1",
                      whiteSpace: "nowrap", // 텍스트를 한 줄로 유지
                      overflow: "hidden", // 넘치는 텍스트를 숨김
                      textOverflow: "ellipsis", // 넘치는 텍스트를 "..."으로 표시
                    }}
                  >
                    {consultingData?.fileOriginFileName4}
                  </LSBdH1HeadLine>
                  <img
                    src="/assets/icons/clip_disabled.png"
                    alt="파일 업로드"
                    style={{
                      width: 16,
                      height: 16,
                      objectFit: "cover",
                    }}
                  />
                </InputFileWrapper>
              </InputLabel>
              <InputLabel>
                <InputTitleWrapper>
                  <LSBdH1HeadLine style={{ color: "#101113" }}>
                    최근 결산기 부가가치세 과세표준증명원{" "}
                  </LSBdH1HeadLine>
                  <LSRgCaption03 style={{ color: "#101113" }}>
                    (사업자일 경우)
                  </LSRgCaption03>
                  <InputTitleRequiredDot />
                </InputTitleWrapper>
                <InputFileWrapper
                  $isSmall={isSmall}
                  onClick={() => {
                    fileDownload(
                      consultingData?.fileServerFileName5,
                      consultingData?.fileOriginFileName5,
                    );
                  }}
                >
                  <LSBdH1HeadLine
                    style={{
                      marginTop: macOSCheck() ? 0 : 2,
                      color: "#A4A8B1",
                      whiteSpace: "nowrap", // 텍스트를 한 줄로 유지
                      overflow: "hidden", // 넘치는 텍스트를 숨김
                      textOverflow: "ellipsis", // 넘치는 텍스트를 "..."으로 표시
                    }}
                  >
                    {consultingData?.fileOriginFileName5}
                  </LSBdH1HeadLine>
                  <img
                    src="/assets/icons/clip_disabled.png"
                    alt="파일 업로드"
                    style={{
                      width: 16,
                      height: 16,
                      objectFit: "cover",
                    }}
                  />
                </InputFileWrapper>
              </InputLabel>

              <InputLabel>
                <InputTitleWrapper>
                  <LSBdH1HeadLine style={{ color: "#101113" }}>
                    개인정보 수집 및 이용 동의(필수)
                  </LSBdH1HeadLine>
                  <InputTitleRequiredDot />
                </InputTitleWrapper>
                <AgreementContainer>
                  <AgreementWrapper className="custom-scrollbar">
                    <PretendardText
                      style={{
                        fontWeight: 400,
                        fontSize: 12,
                        lineHeight: "19.2px",
                        letterSpacing: "-0.6px",
                        color: "#A4A8B1",
                      }}
                    >
                      {termData?.content || ""}
                    </PretendardText>
                  </AgreementWrapper>
                </AgreementContainer>
                <Checkbox
                  id="privacyAgree"
                  name="privacyAgree"
                  checked={true}
                  value="Agree"
                  valueText="개인정보 수집 및 이용에 동의합니다."
                  onChange={() => {}}
                  required={true}
                  style={{ marginTop: 6 }}
                />
              </InputLabel>
            </InputContainer>

            <TableWrapper $isSmall={isSmall}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 4,
                  margin: "60px 0px 20px 0px",
                }}
              >
                <LSRgH1HeadLine>나의 상담 내역</LSRgH1HeadLine>
                <LSRgBody01>
                  이전 진행한 상담 내역을 확인하실 수 있습니다.
                </LSRgBody01>
              </div>

              {/* 본문 영역 - 테이블 */}
              <Table $isSmall={isSmall}>
                <tbody>
                  {postList.length > 0 ? (
                    postList.map((item, index) => (
                      <Tr
                        key={index}
                        $isSmall={isSmall}
                        style={{
                          borderTop: index === 0 && "1px solid #dbdde0",
                        }}
                      >
                        <td
                          style={{
                            display: "flex",
                            width: 315,
                            flexDirection: "column",
                            gap: 10,
                          }}
                        >
                          <LSRgBody01
                            style={{
                              width: 315,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                            onClick={() => {
                              navigate(
                                `${route.consulting_progress_detail}/${item.id}`,
                              );
                            }}
                          >
                            {item.necessaryPart}
                          </LSRgBody01>
                          <div
                            style={{
                              display: "flex",
                              paddingLeft: 68,
                              justifyContent: "flex-end",
                              alignItems: "center",
                              gap: 10,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 6,
                              }}
                            >
                              <img
                                style={{
                                  width: 14,
                                  height: 14,
                                  objectFit: "cover",
                                }}
                                src={"/assets/icons/user.png"}
                                alt={"작성자"}
                              />
                              <LSRgBody01
                                style={{
                                  width: 86,
                                  color: "#898E99",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {item.name}
                              </LSRgBody01>
                            </div>
                            <LSRgBody01 style={{ width: 88, color: "#898E99" }}>
                              {moment(item.createdAt).format("YYYY.MM.DD")}
                            </LSRgBody01>
                          </div>
                        </td>
                      </Tr>
                    ))
                  ) : (
                    <Empty title={"이전 컨설팅 내역이 없습니다."} />
                  )}
                </tbody>
              </Table>

              {postList.length > 0 && (
                <Pagination
                  route={`${route.consulting_progress_detail}/${id}`}
                  queryString={``}
                  currentPage={Number(page) || 1}
                  totalPages={pagination.totalPages}
                  rangeSize={pagination.rangeSize}
                />
              )}
            </TableWrapper>
          </ContentContainer>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              width: "100%",
              position: "sticky",
              bottom: 20,
            }}
          >
            <WriteBtnMobile
              onClick={() => {
                navigate(route.consulting_progress);
              }}
            >
              <img
                style={{
                  width: 30,
                  height: 30,
                  objectFit: "cover",
                }}
                src={"/assets/icons/pen_white.png"}
                alt="글쓰기"
              />
              <LSRgCaption02 style={{ color: "#fff" }}>
                새 서류 제출
              </LSRgCaption02>
            </WriteBtnMobile>
          </div>
        </MOContainer>
      )}
    </HomeSection>
  );
};

export default ConsultingProgressDetail;

const HomeSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: ${(props) =>
    props.$isSmall ? "40px 0px 80px 0px" : "80px 0px 150px 0px"};
`;

const TabContainer = styled.div.attrs((props) => {})`
  width: 175px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Tab = styled.button.attrs((props) => {})`
  width: 175px;
  height: 45px;
  background-color: ${(props) => (props.isActive ? "#5050FF" : "transparent")};
  border: ${(props) => (props.isActive ? "" : "1px solid #A4A8B1")};
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ContentContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: fit-content;
  display: flex;
  flex-direction: column;
`;

const ContentWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  width: 995px;
  height: fit-content;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  padding: 60px 40px;
  margin-bottom: 60px;
`;

const ContentHeaderWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$isSmall ? "16px" : "10px")};
  margin-bottom: ${(props) => (props.$isSmall ? "40px" : "30px")};
`;

const TableWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: fit-content;
`;

const Table = styled.table.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  border-spacing: 0px;
  border-collapse: collapse;
`;

const Tr = styled.tr.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: ${(props) => (props.$isSmall ? "76px" : "64px")};
  border-bottom: 1px solid #dbdde0;
  padding: 16px 10px;
  display: flex;
  align-items: center;
`;

const InputContainer = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: ${(props) => (props.$isSmall ? "20px" : "2px")};
`;

const InputTitleWrapper = styled.div.attrs((props) => {})`
  padding-left: 5px;
  display: flex;
  gap: 2px;
`;

const InputTitleRequiredDot = styled.span.attrs((props) => {})`
  width: 4px;
  height: 4px;
  background-color: #f24147;
  border-radius: 50%;
`;

const InputFileWrapper = styled.div.attrs((props) => {})`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #a4a8b1;
  border-radius: 15px;
  width: ${(props) => (props.$isSmall ? "335px" : "447px")};
  height: 56px;
  gap: 10px;
  cursor: pointer;
`;

const AgreementContainer = styled.div.attrs((props) => {})`
  width: 100%;
  height: 125px;
  border: 1px solid #dbdde0;
  border-radius: 12px;
  padding: 15px;
  display: flex;
  flex-direction: column;
`;

const AgreementWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: 95px;
  overflow-y: auto;
`;

const WriteBtnMobile = styled.button.attrs((props) => {})`
  position: sticky;
  bottom: 20px;
  right: 20px;
  width: 75px;
  height: 75px;
  background-color: #5050ff;
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
`;
